import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import useMemoryState from '../../hooks/memoryStateHook';
import NotasCreditoClientes from './NotasCreditoClientes/NotasCreditoClientes';
import NotasCreditoFornecedores from './NotasCreditoFornecedores/NotasCreditoFornecedores';


export default function NotasCredito() {

    const [tab, setTab] = useMemoryState('nc-tab', 0)


    return (
        <div style={{ margin: 20 }}>
            {/* TODO add this back to Tabs variant='soft-rounded' */}
            <Tabs  selectedIndex={tab} onSelect={(index) => setTab(index)}>
                <TabList>
                    <Tab>Clientes</Tab>
                    <Tab>Fornecedores</Tab>


                </TabList>

                <TabPanel>
                    {tab == 0 ? <NotasCreditoClientes /> : null}

                </TabPanel>
                <TabPanel>
                    {tab == 1 ? <NotasCreditoFornecedores /> : null}

                </TabPanel>
            </Tabs>
        </div>
    )


}